import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Detects a `chatChannel` URL search parameter and auto-opens the chat
 * drawer with the specified channel selected. Strips the parameter from
 * the URL after processing (using replaceState to avoid a history entry).
 *
 * Used in ChatLauncher so it works on any page that renders the chat.
 *
 * Action types match chatActions.js (syncAction creators are untyped JS;
 * dispatching raw action objects avoids TS cast gymnastics and is the same
 * pattern used in chatRedirectSaga.js).
 */
const useChatChannelParam = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const channelUrl = params.get('chatChannel');
    if (!channelUrl) return;

    // Force-select channel + open drawer (same action types as chatRedirectSaga.js)
    dispatch({ type: 'CHAT/SET_ACTIVE_CHANNEL_FORCE', payload: { name: channelUrl, companyId: '' } });
    dispatch({ type: 'CHAT/SET_OPEN', payload: true });

    // Strip chatChannel from URL without creating a history entry
    params.delete('chatChannel');
    const newSearch = params.toString();
    const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '') + window.location.hash;
    window.history.replaceState(null, '', newUrl);
  }, [dispatch]);
};

export default useChatChannelParam;
